// Static brand content for HESHAURA — bracelet-only storefront.

export const BRAND = {
  name: "HESHAURA",
  tagline: "Bracelets for a Brighter You",
  muse: "Heena",
  offer: "33% OFF FIRST ORDER",
  referralReward: "₹333",
};

export const NAV_LINKS = [
  { label: "Shop Bracelets", href: "/shop" },
  { label: "New Arrivals", href: "#new-arrivals" },
  { label: "Collections", href: "#collections" },
  { label: "Our Story", href: "#our-story" },
];

export const CRAFT_STAGES = [
  {
    step: "01",
    title: "Thread & Stone Selection",
    text: "Every bracelet begins with hand-picked chains, stones and charms chosen for colour and character.",
  },
  {
    step: "02",
    title: "Hand Finishing",
    text: "Settings are polished and finished one bracelet at a time — never on a production line.",
  },
  {
    step: "03",
    title: "Charm Setting",
    text: "Each charm is set by a single artisan's hands, with care.",
  },
  {
    step: "04",
    title: "Aura Finishing",
    text: "A final hand-finish gives each bracelet the warm, lived-in glow HESHAURA is known for.",
  },
];

// Brand-level materials storytelling. A product only displays a material when
// its id is explicitly listed in that product's `materials` array.
export const MATERIALS = [
  { id: "silver-925", title: "925 Sterling Silver", text: "A timeless, durable metal with a soft, luminous finish." },
  { id: "gold-accents", title: "Gold Accents", text: "Warm gold detailing, worked in small studio batches." },
  { id: "natural-gemstones", title: "Natural Gemstones", text: "Stones chosen for their colour, character and depth." },
  { id: "artisanal-studio", title: "Artisanal Studio", text: "Every bracelet is finished by hand, one bench at a time." },
];

export const MATERIAL_CATALOG = Object.fromEntries(MATERIALS.map((m) => [m.id, m.title]));

export const formatINR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
